<template>
    <div class="pageClass">
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>

        <NavBar></NavBar>

        <!--搜尋列-->
        <div class="d-flex p-2 m-2">
            <div calss="">
                <select class="form-select LessonLanguage GroupSelect" aria-label="Default select example" v-model="SelectedLanguage"   @change="selectLanguageOption()">
                    <option selected v-bind:value="''">語言</option>
                    <option v-for="(Language,index) in LanguageList" v-bind:value="index" >{{Language}}</option>
                </select>
            </div>
            <div calss="" style="margin:0 8px">
                <select class="form-select LessonName GroupSelect" aria-label="Default select example" v-model="SelectedLessonNames"  @change="selectLessonNameOption()">
                    <option selected v-bind:value="''">課程名稱</option>
                    <option v-for="(LessonName,index) in LessonNamesList" v-bind:value="index">{{index}}</option>
                </select>
            </div>
            <div calss="">
                <button class="ShareBTN" @click="SearchLessonCalendar()">搜尋</button>
            </div>
        </div>
        
        <!--行事曆-->
        <div class="FullCalendarDiv m-2">
            <FullCalendar ref="fullCalendar" :options="calendarOptions" 
                data-toggle="modal" data-target="#ConfirmBookingModal" 
            />
        </div>
        
        <!-- ConfirmBookingModal -->        
        <div class="modal fade" id="ConfirmBookingModal" tabindex="-1" aria-labelledby="ConfirmBookingModalLabel" data-backdrop="static" aria-hidden="true" v-if="showBookingModal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showBookingModal = false">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body ">
                        <div>
                            <span>課程：{{SelectedObject.LessonName}}</span><br/>
                            <span>教材：<button class="ShareBTN" @click="PreviewMaterial()">教材預覽</button></span><br/>
                            <span>訂課時間：{{dateFormat(SelectedObject.StartTimeStamp,0)}}</span><br/>
                            <span data-toggle="modal" data-target="#TeacherInfoModal" @click="GetTeacherInformation()">
                                授課老師：
                                <img :src="SelectedObject.TeacherPhoto" class="GroupTeacherInfoIMG">
                                <u>{{SelectedObject.TeacherName}}</u>
                            </span><br/>
                            <span>消耗：{{SelectedObject.Point}}</span><span v-if="SelectedObject.Point!=0">{{SelectedObject.PointUnit}}</span><br/>
                            <span>請確認是否要訂課?</span>
                        </div>
                        <div class=" d-flex justify-content-end ">
                            <button type="button" class="ShareBTN m-1" data-dismiss="modal" @click="showBookingModal = false">取消</button>
                            <button type="button" class="ShareBTN m-1" @click="StudentBooking()" data-dismiss="modal">確認</button>
                        </div>
                    </div>
                    <div class="modal-footer">
                    </div>
                </div>
            </div>
        </div>

        
        <!-- TeacherInfoModal -->        
        <div class="modal fade" id="TeacherInfoModal" tabindex="-1" aria-labelledby="TeacherInfoModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                    <h5>{{TeacherInfoObjects.TeacherName}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="PauseTeacherVoice()">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body ">
                        <div class=" InfoTop">
                            <div class="">
                                <img :src="TeacherInfoObjects.TeacherPhoto" class="TeacherInfoIMG">
                            </div>
                        </div>
                        <div class="LessonDetailTable">
                            <div class="d-flex p-2 align-self-start">
                                <div class="TeacherInfoSubTitle">
                                    教學年資
                                </div>
                                <div class="ml-2">{{TeacherInfoObjects.ExpYear}}
                                </div>
                            </div>
                            <div class="d-flex p-2">
                                <div class="TeacherInfoSubTitle">
                                    適合學員
                                </div>
                                <div class="ml-2">
                                    <span v-for="(LevelList,index) in TeacherInfoObjects.TeachingLevelList">
                                        {{LevelList}}
                                    </span>
                                </div>
                            </div>
                            <div class="d-flex p-2">
                                <div class="TeacherInfoSubTitle">
                                    教學風格
                                </div>
                                <div class="ml-2 flex-shrink-1">
                                    <span v-for="(StyleList,index) in TeacherInfoObjects.TeacherStyleList">
                                        {{StyleList}}
                                    </span>
                                </div>
                            </div>
                            <div class="d-flex p-2">
                                <div class="TeacherInfoSubTitle">
                                    教學背景
                                </div>
                                <div class="ml-2">
                                    <span v-html="TeacherInfoObjects.TeachingBackground"></span>
                                </div>
                            </div>
                            <div class="d-flex p-2">
                                <div class="TeacherInfoSubTitle">
                                    證照證書
                                </div>
                                <div class="ml-2">
                                    <span v-html="TeacherInfoObjects.Certificate"></span>
                                </div>
                            </div>
                            <div class="d-flex p-2">
                                <div class="TeacherInfoSubTitle">
                                    教師介紹
                                </div>
                                <div class="ml-2">
                                    <button class="ShareBTN" @click="PlayTeacherVoice(TeacherInfoObjects.TeacherVoice)">撥放音檔</button>
                                    <button class="ShareBTN" @click="PauseTeacherVoice()">暫停音檔</button>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div>
                            <span v-html="TeacherInfoObjects.TeacherSelfIntro"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import axios from 'axios'
import moment from 'moment'

import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'

export default {
    name: 'BookingLessonGroup',
    components:{
        NavBar,FullCalendar 
    },
    data () {
        return {
            Token:'',
            showLoading:false,
            showBookingModal:false,
            LanguageList:{},
            LessonNamesList:[],
            SelectedLanguage:'',
            SelectedLessonNames:'',
            DayObject:[],
            TeacherVoice:'',
            GetCalendarInputdata:{
                StartTimeStamp:'',
                EndTimeStamp:''
            },
            SelectedObject:{},
            TeacherInfoObjects:{},
            calendarOptions: {
                plugins: [ dayGridPlugin, interactionPlugin ,listPlugin  ],
                initialView : window.innerWidth < 720 ? 'listWeek':'dayGridMonth',
                headerToolbar: {
                    left: 'prev,next',
                    center: 'title',
                    right: 'today'
                },
                events:[],
                eventClick:this.BookingLesson,
                height: 800,
                eventDisplay: 'auto',
                eventTimeFormat: { 
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                },
                customButtons: {
                    prev: {
                        text: '上月',
                        click: () => {           
                            let calendarApi = this.$refs.fullCalendar.getApi();
                            calendarApi.prev();
                            this.SearchLessonCalendar();
                        }
                    },
                    next: { 
                        text: '下月',
                        click: () => {      
                            let calendarApi = this.$refs.fullCalendar.getApi();
                            calendarApi.next();
                            this.SearchLessonCalendar();
                        }
                    },
                    today: {
                        text: '今天',
                        click: () => {           
                            let calendarApi = this.$refs.fullCalendar.getApi();
                            calendarApi.today();
                            this.SearchLessonCalendar();
                        }
                    },
                },
            }
        }
    },
    methods:{
        // 搜尋
        SearchLessonCalendar(){
            let calendarApi = this.$refs.fullCalendar.getApi();
            this.GetCalendarInputdata.StartTimeStamp = moment(calendarApi.currentData.dateProfile.currentRange.start).startOf('day').format("X")
            this.GetCalendarInputdata.EndTimeStamp = moment(calendarApi.currentData.dateProfile.currentRange.end).add(-1,'days').endOf('day').format("X")
            
            this.GetGroupLessonCalendar();
        },
        // 點選課程event
        BookingLesson(info){
            // console.log(info.event._def.extendedProps);
            this.showBookingModal = true;
            this.SelectedObject = info.event._def.extendedProps;
        },
        // TimeStamp轉換
        dateFormat(timestamp,type){
            if(timestamp && timestamp != "")
            {
                if(type == 0){
                    return moment.unix(timestamp).format("yyyy-MM-DD HH:mm:ss");
                }else{
                    return moment.unix(timestamp).format("HH:mm");
                }
            }
            return "";
        },
        // 播放音檔
        PlayTeacherVoice(TeacherVoiceURL){
            this.TeacherVoice = new Audio(TeacherVoiceURL);
            this.TeacherVoice.play();
        },
        // 暫停撥放音檔
        PauseTeacherVoice(){
            if(this.TeacherVoice != ""){
                this.TeacherVoice.pause();
                this.TeacherVoice = "";
            }
        },
        // 確認訂課
        StudentBooking(){
            this.showBookingModal = false
            this.StudentBooking();
        },
        // 開啟教師簡介
        OpenTeacherInfo(){
            this.GetTeacherInformation();
        },        
        //教材預覽
        PreviewMaterial(){
            window.open(this.SelectedObject.PreviewMaterialUrl, '_blank');
        },
        // 語言
        selectLanguageOption:function(){
            if(this.SelectedLessonNames != '' && this.SelectedLanguage !=''){
                this.SelectedLessonNames = '';
            }
            this.GetGroupLessonsByLanguange();
        },
        // 選取課程名稱
        selectLessonNameOption(){
            if(this.SelectedLessonNames != ''){
                this.SelectedLanguage = this.LessonNamesList[this.SelectedLessonNames];
            }else{
                this.SelectedLanguage = '';
            }
        },

        /*API*/
        //取得下拉搜尋
        GetGroupLessonSearchConditions(){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Student/GetGroupLessonSearchConditions`;
            const headers = {"Authorization": 'Bearer '+this.Token};
            const inputdata = {};

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.Result){
                        this.LanguageList = response.data.Languages;
                        this.LessonNamesList = response.data.LessonNames;
                    }else{
                        if(response.data.errorCode == 20002){
                            alert("閒置時間過長，請重新進入。");
                        }else{
                            alert(response.data.Message);
                        }
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert("下拉選單取得失敗："+ error.message);
                });
        },
        //取得下拉課程名稱
        GetGroupLessonsByLanguange(){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Student/GetGroupLessonsByLanguange`;
            const headers = {"Authorization": 'Bearer '+this.Token};
            const inputdata = {};
            
            if(this.SelectedLanguage != ''){
                inputdata.language = parseFloat(this.SelectedLanguage);
            }

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.Result){
                        this.LessonNamesList = response.data.LessonNames;
                    }else{
                        if(response.data.errorCode == 20002){
                            alert("閒置時間過長，請重新進入。");
                        }else{
                            alert(response.data.Message);
                        }
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert("下拉選單取得失敗："+ error.message);
                });
        },
        //取得選取月份資料
        GetGroupLessonCalendar(){
            // console.log(this.GetCalendarInputdata);
            this.calendarOptions.events = [];
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Student/GetGroupLessonCalendar`;
            const headers = {"Authorization": 'Bearer '+this.Token};
            const inputdata = this.GetCalendarInputdata;
            if(this.SelectedLanguage != ''){
                inputdata.language = parseFloat(this.SelectedLanguage);
            }
            if(this.SelectedLessonNames != ''){
                inputdata.LessonName = this.SelectedLessonNames;
            }

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.Result){
                        if(response.data.DayObjects == null){
                            console.error(response.data.Message);
                            alert(response.data.Message);
                            return;
                        }
                        // this.calendarOptions.events.push({ title: '09:00-09:30 實用韓文', date: '2022-05-19' });
                        this.DayObject = response.data.DayObjects;
                        this.DayObject.forEach(ItemObject => {
                            if(ItemObject.bookingDetails.length > 0){
                                ItemObject.bookingDetails.forEach(Item => {
                                    this.calendarOptions.events.push({
                                        title:Item.LessonName + ' ' + Item.TeacherName ,
                                        start:moment.unix(Item.StartTimeStamp).format("YYYY-MM-DDTHH:mm"),
                                        end:moment.unix(Item.EndTimeStamp).format("YYYY-MM-DDTHH:mm"),
                                        StartTimeStamp: Item.StartTimeStamp,
                                        EndTimeStamp: Item.EndTimeStamp,
                                        Gender: Item.Gender,
                                        LessonId: Item.LessonId,
                                        LessonTime: Item.LessonTime,
                                        Point:Item.Point,
                                        PointUnit:Item.PointUnit,
                                        TeacherId: Item.TeacherId,
                                        TeacherName: Item.TeacherName,
                                        TeacherPhoto: Item.TeacherPhoto,
                                        languageType: Item.languageType,
                                        LessonName: Item.LessonName,
                                        PreviewMaterialUrl: Item.PreviewMaterialUrl,
                                        
                                    });
                                });
                                
                            }
                        });
                    }else{
                        if(response.data.errorCode == 20002){
                            alert("閒置時間過長，請重新進入。");
                        }
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert("課程資料取得失敗："+ error.message);
                });
        },
        //取得老師介紹
        GetTeacherInformation(){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Student/GetTeacherInformation`;
            const headers = {"Authorization": 'Bearer '+this.Token};
            const inputdata = 
            {
                "TeacherId": this.SelectedObject.TeacherId,
            };

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.Result){
                        this.TeacherInfoObjects = response.data.TeacherInfoObjects;
                    }else{
                        if(response.data.errorCode == 20002){
                            alert("閒置時間過長，請重新進入。");
                        }else{
                            alert(response.data.Message);
                        }
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert("教師介紹取得失敗："+ error.message);
                });
        },
        //訂課
        StudentBooking(){
            this.showLoading = true;
            var api =`${process.env.APIPATH}/api/Student/StudentBooking`;
            const headers = {"Authorization": 'Bearer '+this.Token};
            const inputdata = 
            {
                "LessonId": this.SelectedObject.LessonId,
                "TeacherId": this.SelectedObject.TeacherId,
                "BookingTimeStamp": this.SelectedObject.StartTimeStamp,
            };

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.Result){
                        alert("訂課成功！");
                        this.$router.push({name: 'Home'});
                    }else{
                        if(response.data.errorCode == 20002){
                            alert("閒置時間過長，請重新進入。");
                        }else{
                            alert("訂課失敗："+response.data.Message);
                        }
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert("訂課失敗："+ error.message);
                });
        },
    },    
    mounted(){
        this.SearchLessonCalendar();
        // this.GetGroupLessonCalendar();
    },
    created(){
        this.Token = sessionStorage.getItem('Token');
        this.GetGroupLessonSearchConditions();
    },
}
</script>





// WEBPACK FOOTER //
// src/components/pages/BookingLessonGroup.vue